module.exports = __webpack_public_path__ + "img/1_013.de3516cc.jpg";